import { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { MenuItem, TextField } from '@mui/material';

import calculateEnabledStatus from '../utils/calculateEnabledStatus';

QuestionnaireChoice.propTypes = {
  element: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func,
  values: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
};

function QuestionnaireChoice(props) {
  const { element, setFieldValue, values, readOnly } = props;

  const [notDisabled, setNotDisabled] = useState(true);

  const currentValue = useMemo(() => values[element.linkId] || '', [element.linkId, values]);

  useEffect(() => {
    if (element.enableBehavior) {
      const enableStatus = calculateEnabledStatus(element.enableBehavior, element.enableWhen, values);
      setNotDisabled(enableStatus !== undefined && enableStatus);
    }
  }, [element.enableBehavior, element.enableWhen, values]);

  const handleChange = useCallback((e) => {
    setFieldValue(element.linkId, e.target.value || '');
  }, [setFieldValue, element.linkId]);

  return (
    <TextField
      fullWidth
      select
      disabled={!notDisabled}
      label={element.required ? `${element.text}*` : element.text}
      value={currentValue}
      onChange={handleChange}
      type={element.type === 'integer' || element.type === 'decimal' ? 'number' : 'text'}
      variant={readOnly ? "standard" : "outlined"}
      InputProps={{ readOnly }}
    >
      {element.answerOption?.map((option) => (
        <MenuItem key={option.valueCoding?.code} value={option.valueCoding?.code}>
          {option.valueCoding?.display}
        </MenuItem>
      ))}
    </TextField>
  );
}

export default QuestionnaireChoice;
